<template>
  <div>
    <section-title
      class="mt-4 pt-1"
      :has-line="true"
      title="Informes EDEN"
      title-class="font-14"
    />
    <file-detail
      title="Informes LEA"
      :items="leaFiles"
      :report-file-type="reportFileTypeEnum.LEA"
      :allow-to-submit="allowToSubmit"
      @on-open-details="openDetailsHandler"
      @on-amend-file="$emit('on-amend-file', $event)"
      @on-download-file="$emit('on-download-file', $event)"
    />
    <file-detail
      title="Informes SEA"
      :items="seaFiles"
      :report-file-type="reportFileTypeEnum.SEA"
      :allow-to-submit="allowToSubmit"
      @on-open-details="openDetailsHandler"
      @on-amend-file="$emit('on-amend-file', $event)"
      @on-download-file="$emit('on-download-file', $event)"
    />
    <file-detail
      v-if="showSchFiles"
      title="Informes SCH"
      :items="schFiles"
      :report-file-type="reportFileTypeEnum.SCH"
      :allow-to-submit="allowToSubmit"
      @on-open-details="openDetailsHandler"
      @on-amend-file="$emit('on-amend-file', $event)"
      @on-download-file="$emit('on-download-file', $event)"
    />
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
import FileDetail from "./FileDetails.vue";
import reportFileType from "@/utils/constants/reportFileType.js";
export default {
  name: "FileContainer",
  components: {
    SectionTitle,
    FileDetail,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    allowToSubmit: {
      type: Boolean,
      default: () => false,
    },
    showSchFiles:{
      type: Boolean,
      default: () => false,
    }
  },
  data: () => ({
    leaFiles: [],
    seaFiles: [],
    schFiles:[]
  }),
  computed: {
    reportFileTypeEnum() {
      return reportFileType;
    },
  },
  watch: {
    files: {
      immediate: true,
      handler() {
        this.leaFiles = this.files.filter(
          (t) => t.fileType.name == reportFileType.LEA
        );
        this.seaFiles = this.files.filter(
          (t) => t.fileType.name == reportFileType.SEA
        );
        this.schFiles = this.files.filter(
          (t) => t.fileType.name == reportFileType.SCH
        );
      },
    },
  },
  methods: {
    openDetailsHandler(index, item, option, reportType) {
      if (
        (item.selectedOption !== option && !item.isOpen) ||
        item.selectedOption == option
      ) {
        this.toggleOpen(option, index, reportType);
      }
    },
    toggleOpen(option, index, reportType) {
      if (reportType == reportFileType.SEA) {
        this.seaFiles = this.seaFiles.map((item, itemIndex) => {
          if(itemIndex === index)
          {
            item.isOpen = index === itemIndex ? !item.isOpen : false;
            if (item.selectedOption != option) {
              item.isOpen = true;
            }
            item.selectedOption = option;            
          }          
          return item;
        });
      }
      if (reportType == reportFileType.LEA) {
        this.leaFiles = this.leaFiles.map((item, itemIndex) => {
          if(itemIndex === index)
          {
            item.isOpen = index === itemIndex ? !item.isOpen : false;
            if (item.selectedOption != option) {
              item.isOpen = true;
            }
            item.selectedOption = option;
          }
          return item;
        });
      }
      if (reportType == reportFileType.SCH) {
        this.schFiles = this.schFiles.map((item, itemIndex) => {
          if(itemIndex === index)
          {
            item.isOpen = index === itemIndex ? !item.isOpen : false;
            if (item.selectedOption != option) {
              item.isOpen = true;
            }
            item.selectedOption = option;
          }
          return item;
        });
      }
    },
  },
};
</script>
